
/* Developed by Vijay G */

import { Component, OnInit, Input, Output, EventEmitter, NgModule } from '@angular/core';
import { FormControl, FormGroup, FormBuilder, Validators, ValidatorFn, AbstractControl } from '@angular/forms';
import { Router } from '@angular/router';
import { Message, ConfirmationService } from 'primeng/primeng';
import { TranslateService } from '@ngx-translate/core';
import { SelectItem } from 'primeng/primeng';
import { EditPopup } from '../.././shared/edit-popup';
import { SharedService } from '../.././shared/shared.service';
import { BaseComponent } from '../.././shared/base.component';
import { FPMessage, Severities, RoleAccess,ProductCategory, SaveProductCategory } from '../.././shared/shared.model';
import { CapitalizeFirstPipe } from '../.././shared/pipes/custom-pipes.pipe';


@Component({
    selector: 'product-category-add-edit',
    templateUrl: 'product-category-add-edit.component.html'
})

export class ProductCategoryAddEditComponent extends BaseComponent implements OnInit, EditPopup {
    @Input() header: string;
    @Input() productcategoryId: number;
    @Input() ProductCategory: ProductCategory;
    @Input() productCategoryName: string;
    @Output() done = new EventEmitter();

    frmProductcategory: FormGroup;
    SaveProductCategory: SaveProductCategory[] = [];
    submitted: boolean = false;
    isVisible: boolean = false;
    savedProductCategory :string;


    message: FPMessage;
    isEdit: boolean = true;
    brandmasval: number;
    

    constructor(private router: Router, public sharedService: SharedService,
        protected translate: TranslateService, private formBuilder: FormBuilder,
        private confirmationService: ConfirmationService) {
        super(sharedService, translate);

    }

    ngOnInit() {debugger
        this.frmProductcategory = this.formBuilder.group({
            ProductCategory: ['', Validators.required],
            Description: ['', Validators.maxLength(1000)],
            IsActive: [0],
        });
        if (this.productcategoryId != 0) {
            
            this.isEdit = (this.productcategoryId != null && this.productcategoryId > 0) ? true : false;
            this.getProduct(super.globalInfo().CompanyId, this.productcategoryId);
        }
    } //ngOnInit ends

    getProduct(CompanyId: number, ProductCategoryId: number) {
         debugger
        this.sharedService.getProduct(CompanyId, ProductCategoryId).subscribe(s => {
            debugger
                this.frmProductcategory.patchValue({
                    ProductCategory: s.ProductCategory,
                    Description: s.Description,
                    IsActive: s.IsActive == 0 ? 1 : 0
                })
            });
    }

    save(SaveProductCategory: SaveProductCategory, formValid: boolean) {
        this.submitted = true;

        this.productcategorysave(SaveProductCategory, formValid);
    }

    productcategorysave(SaveProductCategory: SaveProductCategory, formValid: boolean) {
        debugger
         
        if (formValid) {
            SaveProductCategory.ProductCategoryId = this.productcategoryId;
            SaveProductCategory.CompanyId = super.globalInfo().CompanyId;
            SaveProductCategory.LastChangedBy = super.globalInfo().LoginId;

            SaveProductCategory.IsActive = SaveProductCategory.IsActive == 1 ? 0 : 1;

            if (this.productcategoryId > 0) {
                this.sharedService.update(SaveProductCategory).subscribe(s => {
                    this.message = s.Message
                    if(this.productCategoryName == "1")
                    {
                          this.savedProductCategory = s.Data;
                    }
                    if (s.Message.Severity == Severities.success) this.close(true);
                    else {
                        SaveProductCategory.IsActive = SaveProductCategory.IsActive == 1 ? 0 : 1;
                        this.close(false);
                    }
                });
            }
            else {
                 

                SaveProductCategory.CreatedBy = super.globalInfo().LoginId;
                this.sharedService.insert(SaveProductCategory).subscribe(s => {
                    debugger
                    this.message = s.Message;
                  if(this.productCategoryName == "1")
                {
                      this.savedProductCategory = s.Data;
                }

                    if (s.Message.Severity == Severities.success) this.close(true);
                    else {
                        SaveProductCategory.IsActive = SaveProductCategory.IsActive == 1 ? 0 : 1;
                        this.close(false);
                    }
                });

            }
        }
    }

    close(success?: boolean) {
        debugger
        if (success || success == false) {
            if (this.message.MessageCode == "1001" || this.message.MessageCode == "1002") {
                this.sharedService.notification.emit({
                    severity: Severities[this.message.Severity],
                    summary: CapitalizeFirstPipe.prototype.transform(Severities[this.message.Severity]),
                    detail: this.translate.instant('PRODUCTCATEGORY') + " " + this.translate.instant(this.message.MessageCode)
                });
            }
            else {
                this.sharedService.notification.emit({
                    severity: Severities[this.message.Severity],
                    summary: CapitalizeFirstPipe.prototype.transform(Severities[this.message.Severity]),
                    detail: this.translate.instant(this.message.MessageCode)
                });
            }


            if(this.productCategoryName == "1"){
                this.done.emit(this.savedProductCategory);
            }
            else{
                this.done.emit(success);
            }
            
        }
        else if (success == null || success == undefined)
                
        this.done.emit(null);
                        
          }

}